import { cssClass, waitForImageLoad } from '../helpers/dom-interact';

const baseClass = 'is-hotfoil';

export class HotfoilEffect {
	constructor(options) {
		this.element = options.element;
		this.activeEffect = '';
		this.imageLoaded = false;

		if (options.effect) {
			this.applyOnImageLoad(options.effect);
		}
	}

	applyOnImageLoad(effect) {
		const onImageLoaded = waitForImageLoad(this.element);

		onImageLoaded.then(() => {
			this.imageLoaded = true;
			this.set(effect);
		});

		onImageLoaded.catch((error) => {
			throw new Error(`Unable to apply hotfoil effect; ${error}`);
		});
	}

	set(effect) {
		if (!this.imageLoaded || typeof effect !== 'string' || effect === this.activeEffect) {
			return;
		}

		this.activeEffect = effect;

		cssClass.add(this.element, [baseClass, effect]);
	}

	remove() {
		cssClass.remove(this.element, [baseClass, this.activeEffect]);

		this.activeEffect = '';
	}

	update(newEffect) {
		if (!this.imageLoaded) {
			return;
		}

		if (typeof newEffect !== 'string' || newEffect === this.activeEffect) {
			return;
		}

		cssClass.replace(this.element, this.activeEffect, newEffect);

		this.activeEffect = newEffect;
	}
}
